<template>
  <div class="weeks">
    <span id="w-add-up">
      <WeeksAddUpdate
        v-if="showAdd"
        @showAdd="close"
        @showMore="showMore"
        :page="page"
        :titleCard="titleCard"
        :updateData="updateData"
        :weekGroup="weekGroup"/>
    </span>
    <span id="w-send">
      <WeeksSendNotification
        v-if="showNotify"
        @close="closeNotify"
      />
    </span>
    <va-card :title="$t('weeks.cards.title') + ' - ' + 'Grupo ' + this.weekGroup">
      <template slot="actions">
        <va-button
          color="red"
          href="#w-send"
          icon="fa fa-send-o"
          @click="notify()"
        />
        <va-button
          @click="open"
          href='#w-add-up'
          icon="fa fa-plus"
        />
      </template>
      <va-data-table
        :fields="fields"
        :data="weeks"
        :per-page="perPage"
        :totalPages="totalPages"
        :loading="loading"
        @page-selected="showMore"
        no-data-label="Sem Dados Cadastrados"
        api-mode
      >
        <template slot="actions" slot-scope="props">
          <va-popover :message="`${$t('weeks.tooltips.ranking_s1')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-star"
              :to="{ name: 'weeks-ranking-s1', params: { week: props.rowData.id } }"
            />
          </va-popover>
          <va-popover :message="`${$t('weeks.tooltips.ranking')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-signal"
              :to="{ name: 'weeks-ranking', params: { week: props.rowData.id } }"
            />
          </va-popover>
          <va-popover :message="`${$t('weeks.tooltips.games')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-list-alt"
              :to="{ name: 'games', params: { week: props.rowData.id } }"
            />
          </va-popover>
          <va-popover v-if="!(props.rowIndex === 0 && page === 1)" :message="`${$t('weeks.tooltips.points')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-trophy"
              :to="{ name: 'weeks-points', params: { week: props.rowData.id } }"
            />
          </va-popover>
          <va-popover v-if="props.rowIndex === 0 && page === 1" :message="`${$t('weeks.tooltips.games')} API`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-cloud-download"
              :to="{ name: 'gamesAPI', params: { week: props.rowData.id } }"
            />
          </va-popover>
          <va-popover :message="`${$t('weeks.tooltips.update')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-pencil"
              href='#w-add-up'
              @click="update(props.rowData)"
            />
          </va-popover>
          <va-popover :message="`${$t('tooltips.delete')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-trash"
              @click="showModal(props.rowData)"
            />
          </va-popover>
        </template>
      </va-data-table>
    </va-card>
    <va-modal
      v-model="modalDeletar"
      size="small"
      :title="$t('modals.titleDelete')"
      :message="$t('weeks.modals.message')"
      :okText="$t('modals.confirm') "
      :cancelText="$t('modals.cancel')"
      @ok="deleting"
    />
  </div>
</template>

<script>
import gql from 'graphql-tag'
import WeeksAddUpdate from './WeeksAddUpdate'
import WeeksSendNotification from './WeeksSendNotification'

const perPage = 10
export default {
  name: 'weeks',
  props: {
    weekGroup: {
      required: true,
    },
  },
  components: {
    WeeksAddUpdate,
    WeeksSendNotification,
  },
  methods: {
    notify () {
      this.showAdd = false
      this.showNotify = true
    },
    closeNotify (v) {
      this.showNotify = v
    },
    close (v) {
      this.showAdd = v
      this.updateData = null
    },
    update (data) {
      this.titleCard = 'update'
      this.updateData = data
      this.showAdd = true
    },
    open () {
      this.updateData = null
      this.showAdd = true
      this.titleCard = 'create'
    },
    showModal (data) {
      this.modalDeletar = true
      this.deleteId = data
    },
    showMore (page) {
      this.loading = true
      this.page = page
      this.$apollo.queries.weeks.fetchMore({
        variables: {
          page: (page - 1) * this.perPage,
          perPage: this.perPage,
        },
        updateQuery: (_, { fetchMoreResult }) => {
          this.loading = false
          return fetchMoreResult
        },
      })
    },
    deleting () {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation MyMutation($id: Int!) {
              delete_week_by_pk(id: $id) {
                id
              }
            }
          `,
          variables: {
            id: this.deleteId.id,
          },
        })
        .then(data => {
          this.$apollo.queries.pages.refetch()
          this.showMore(this.page)
          this.showToast(
            this.$t('toasts.successDelete'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          this.showToast(
            this.$t('toasts.errorDelete'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
  data () {
    return {
      weeks: [],
      page: 1,
      perPage: perPage,
      pages: null,
      loading: false,
      showAdd: false,
      modalDeletar: false,
      deleteId: 0,
      titleCard: '',
      updateData: null,
      userId: null,
      showNotify: false,
    }
  },
  apollo: {
    weeks: {
      query: gql`
      query MyQuery($page: Int = 0, $perPage: Int = 2, $weekGroupId: Int!) {
        weeks: week(limit: $perPage, offset: $page, order_by: {id: desc}, where: {week_group_id: {_eq: $weekGroupId}}) {
          id
          name
          active
          week_group_id
        }
      }
      `,
      variables () {
        return {
          perPage,
          page: 0,
          weekGroupId: this.weekGroup,
        }
      },
    },
    pages: gql`
    query MyQuery($weekGroupId: Int!) {
      pages: week_aggregate(args: {week_group_id: $weekGroupId}) {
        aggregate {
          count
        }
      }
    }
    `,
    variables () {
      return {
        weekGroupId: this.weekGroup,
      }
    },
  },
  computed: {
    totalPages () {
      return this.pages != null ? Math.ceil(this.pages.aggregate.count / this.perPage) : 0
    },
    fields () {
      return [{
        name: 'id',
        title: this.$t('tables.id'),
        width: '50px',
      }, {
        name: 'name',
        title: this.$t('weeks.headings.name'),
        width: '50%',
      }, {
        name: '__slot:actions',
        title: this.$t('tables.actions'),
        dataClass: 'text-center',
        titleClass: 'text-center',
      }]
    },
  },
  mounted () {
    if (Object.keys(this.$apollo.queries).includes('weeks')) {
      this.$apollo.queries.pages.refetch()
      this.$apollo.queries.weeks.refetch()
    }
  },
}
</script>

<style lang="scss">
</style>
